import React from "react";

function getPersonName(person) {
  return (
    person.full_name ||
    person.display_name ||
    `${person.first_name || ""} ${person.last_name || ""}`.trim() ||
    "Unnamed person"
  );
}

function StatusBadge({ value }) {
  const map = {
    active:
      "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/30 dark:text-green-300 dark:border-green-900",
    inactive:
      "bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-950/30 dark:text-yellow-300 dark:border-yellow-900",
    archived:
      "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-300 dark:border-red-900",
  };

  return (
    <span
      className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${
        map[value] ||
        "bg-gray-50 text-gray-700 border-gray-200 dark:bg-neutral-800 dark:text-gray-300 dark:border-neutral-700"
      }`}
    >
      {value || "-"}
    </span>
  );
}

export default function HRPeopleTable({
  people = [],
  loading = false,
  onRowClick,
  onEdit,
  onArchive,
}) {
  return (
    <div className="bg-white dark:bg-neutral-900 rounded-2xl border border-gray-200 dark:border-neutral-700 shadow-sm overflow-hidden">
      <div className="overflow-auto">
        <table className="w-full min-w-[1100px]">
          <thead className="bg-gray-50 dark:bg-neutral-800/70">
            <tr className="text-left text-sm text-gray-600 dark:text-gray-300">
              <th className="p-3">Name</th>
              <th className="p-3">Type</th>
              <th className="p-3">Status</th>
              <th className="p-3">Department</th>
              <th className="p-3">Team</th>
              <th className="p-3">Position</th>
              <th className="p-3">Manager</th>
              <th className="p-3">Work email</th>
              <th className="p-3">Phone</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td className="p-4 text-sm text-gray-500" colSpan={10}>
                  Učitavanje...
                </td>
              </tr>
            ) : people.length === 0 ? (
              <tr>
                <td className="p-4 text-sm text-gray-500" colSpan={10}>
                  Nema rezultata.
                </td>
              </tr>
            ) : (
              people.map((person) => (
                <tr
                  key={person.id}
                  className="border-t border-gray-100 dark:border-neutral-800 hover:bg-gray-50 dark:hover:bg-neutral-800/60 cursor-pointer"
                  onClick={() => onRowClick?.(person)}
                >
                  <td className="p-3">
                    <div className="font-medium text-black dark:text-white">
                      {getPersonName(person)}
                    </div>
                    <div className="text-xs text-gray-500">
                      {person.employee_code || "-"}
                    </div>
                  </td>

                  <td className="p-3">{person.person_type || "-"}</td>
                  <td className="p-3">
                    <StatusBadge value={person.status} />
                  </td>
                  <td className="p-3">{person.department_name || "-"}</td>
                  <td className="p-3">{person.team_name || "-"}</td>
                  <td className="p-3">{person.position_title || "-"}</td>
                  <td className="p-3">{person.manager_name || "-"}</td>
                  <td className="p-3">{person.email_work || "-"}</td>
                  <td className="p-3">{person.phone_mobile || "-"}</td>

                  <td className="p-3">
                    <div className="flex gap-2">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onEdit?.(person);
                        }}
                        className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700 text-sm"
                      >
                        Edit
                      </button>

                      {person.status !== "archived" && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onArchive?.(person);
                          }}
                          className="px-3 py-1 rounded-lg border border-red-300 text-red-700 bg-red-50 text-sm dark:bg-red-950/30 dark:text-red-300 dark:border-red-900"
                        >
                          Archive
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}